<div [class]="wrapContent ? 'dm-summary-progress-bar dm-flex-wrap' : 'dm-summary-progress-bar'">
  <ng-container *ngFor="let step of progressBarData; let index = index">
    <div class="step" [ngClass]="getClassByStatus(step.status)"
      [ngStyle]="{'height':stepHeight, 'font-size':stepFontSize}">
      <div class="step-content">{{step.content}}</div>
    </div>
  </ng-container>
</div>